<ngx-zero-state>
  <p zero-state-title>{{ 'lti-default-error-title' | translate : translationParams }}</p>
  <div zero-state-subtext>
    @for (error of errors | keyvalue; track error) {
      @switch (error.key) {
        @case ('invalidSignature') {
          <span class="error-title">{{ 'lti-invalid-signature' | translate }}</span>
        }
        @case ('incompleteSetup') {
          <span class="error-title">{{ 'lti-launch-error_incomplete-setup' | translate }}</span>
        }
        @default {
          <span class="error-title">{{ 'common_unknown-error' | translate }}</span>
        }
      }
      <span>{{ error.value }}</span>
    }
  </div>

  <div zero-state-body>
    @if (!errors?.['incompleteSetup']) {
      <div class="action-wrapper">
        @if (setupInstructionsLink) {
          <a
            [href]="setupInstructionsLink"
            target="_blank"
            class="primary-btn stacked-item"
            >
            {{ 'error-renderer-view-setup-instructions' | translate }}
          </a>
        }
        <a
          [href]="contactSupport"
          target="_blank"
          class="tertiary-btn stacked-item"
          >
          {{ 'error-renderer-contact-support' | translate }}
        </a>
      </div>
    }
  </div>
  <div zero-state-graphic-bottom>
    <img [src]="activeBrandService.getImage('crashed-astronaut.svg')" alt="No Results">
  </div>
</ngx-zero-state>
